import { AppConfig } from '../types';

export const testConfig: AppConfig = {
  'base-uri': 'atacarnet-test.iccwbo.org',
  eur: [
    'ad',
    'al',
    'at',
    'ba',
    'be',
    'bg',
    'by',
    'ch',
    'ci',
    'cy',
    'cz',
    'de',
    'dk',
    'dz',
    'ee',
    'es',
    'fi',
    'fr',
    'gb',
    'gi',
    'gr',
    'hr',
    'hu',
    'ie',
    'is',
    'it',
    'lt',
    'lu',
    'lv',
    'ma',
    'md',
    'me',
    'mg',
    'mk',
    'mt',
    'mu',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'rs',
    'ru',
    'se',
    'si',
    'sk',
    'sn',
    'tn',
    'tr',
    'ua',
    'xb',
    'xs',
    'za'
  ],
  ame: [
    'ca',
    'cl',
    'mx',
    'us',
    'xt',
    'pe'
  ],
  asi: [
    'ae',
    'au',
    'bh',
    'cn',
    'hk',
    'id',
    'il',
    'in',
    'ir',
    'jp',
    'kr',
    'kz',
    'lb',
    'lk',
    'mn',
    'mo',
    'my',
    'nz',
    'pk',
    'qa',
    'sg',
    'th',
    'tw',
    'vn',
    'sa',
    'ph'
  ]
};
